export default __webpack_public_path__ + "static/media/arrow-slider-right.143c9486.svg";